type Value<T> = T | undefined | null;

export const assertDefined = <T>(value: Value<T>): T => {
  if (value === null || value === undefined) {
    throw new Error('assert defined error');
  }
  return value;
};
